import { computed, inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { TellentUserAbilitiesSelectors } from '@core/tellent-data';
import { APP_GUID, TellentOrgAbilities } from '@core/tellent-types';

import { TellentCurrentUserDataFacade } from './tellent-current-user-data.facade';

@Injectable({ providedIn: 'root' })
export class TellentAccessService {
  private readonly currentUserFacade = inject(TellentCurrentUserDataFacade);
  public store = inject(Store);
  public appGuid = inject(APP_GUID);
  public canManageTellentUsers = this.store.selectSignal(
    TellentUserAbilitiesSelectors.hasOne(TellentOrgAbilities.ManageUsers),
  );
  public canManageTellent = this.store.selectSignal(
    TellentUserAbilitiesSelectors.hasOne(TellentOrgAbilities.ManageTellent),
  );
  public tellentMember = this.currentUserFacade.organizationMembership;

  public canManageUsersOnAppLevel = computed(() => {
    const tellentMember = this.tellentMember();
    const appAbilities = tellentMember.seats.find(seat => seat.app.guid === this.appGuid)?.role
      ?.abilities;
    return appAbilities?.includes(TellentOrgAbilities.ManageUsers);
  });

  public canAddTellentUsersOnAppLevel = computed(
    () => this.canManageTellentUsers() || this.canManageUsersOnAppLevel(),
  );
}
